export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        program: action.program,
      };
    case 'UPDATE_STEP':
      return {
        ...state,
        program: {
          ...state.program,
          attributes: {
            ...state.program.attributes,
            steps: state.program.attributes.steps.map((step) => (step.id === action.stepId ? action.step : step)),
          },
        },
      };
    case 'UPDATE_TITLE':
      return {
        ...state,
        program: {
          ...state.program,
          attributes: {
            ...state.program.attributes,
            title: action.title,
          },
        },
      };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
